import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, CardBody } from 'reactstrap';
import { useFileUpload } from 'hooks/useFileUpload';
import { API_ENDPOINTS } from 'constants';
import PanelButton from './PanelButton';
import { NEW_ITEM_ID } from 'constants';
import { faCamera, faPlus } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import FileUpload from 'components/modules/uploads/FileUpload';

const DocumentCaptureButton = ({ obj }) => {
    const navigate = useNavigate();
    const fileUpload = useFileUpload(API_ENDPOINTS.UPLOADS.FILE_UPLOAD(NEW_ITEM_ID), true);
    
    const handleAdd = async (uploadId) => {
        navigate(`/admin/${obj}/${NEW_ITEM_ID}/uploads/${uploadId}`, { replace: false });
    };

    const onFilesUpload = (files) => { files.map(file => handleAdd(file.id))}

    return (
        <>
            <PanelButton icon={faCamera} onClick={fileUpload.triggerFileUpload}/>
            <FileUpload fileUpload={fileUpload} onFilesUpload={onFilesUpload}/>
        </>
    );
};

export default DocumentCaptureButton;


//<PanelButton icon={faPlus} onClick={handleAdd}/>